import { Checkbox, CheckboxProps, styled } from '@mui/material';

const StyledIcon = styled('span')(({ theme }) => ({
    borderRadius: theme.spacing(0.75),
    width: 24,
    height: 24,
    backgroundColor: theme.palette.common.white,
    border: `2px solid ${theme.palette.primary.main}`,
    transition: theme.transitions.create(['background-color', 'border-color'], {
        duration: theme.transitions.duration.short,
    }),
    '.Mui-focusVisible &': {
        outline: '2px auto',
        outlineColor: theme.palette.primary.main,
        outlineOffset: 2,
    },
    'input:hover ~ &': {
        backgroundColor: theme.palette.purple?.[100],
    },
    'input:disabled ~ &': {
        boxShadow: 'none',
        background: theme.palette.grey[500],
    },
}));

const StyledCheckedIcon = styled(StyledIcon)(({ theme }) => ({
    backgroundColor: theme.palette.primary.main,
    '&::before': {
        display: 'block',
        width: 24,
        height: 24,
        backgroundImage:
            "url(\"data:image/svg+xml;charset=utf-8,%3Csvg width='12' height='9' viewBox='0 0 12 9' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M11.0156 0.984375C11.3203 1.26562 11.3203 1.75781 11.0156 2.03906L5.01562 8.03906C4.73438 8.34375 4.24219 8.34375 3.96094 8.03906L0.960938 5.03906C0.65625 4.75781 0.65625 4.26562 0.960938 3.98438C1.24219 3.67969 1.73438 3.67969 2.01562 3.98438L4.5 6.44531L9.96094 0.984375C10.2422 0.679688 10.7344 0.679688 11.0156 0.984375Z' fill='white'/%3E%3C/svg%3E\")",
        backgroundRepeat: 'no-repeat',
        backgroundPosition: '35% 35%',
        content: '""',
    },
    'input:hover ~ &': {
        backgroundColor: theme.palette.primary.main,
    },
}));

export default function StyledCheckbox(props: CheckboxProps) {
    return (
        <Checkbox
            sx={{ '&:hover': { bgcolor: 'transparent' } }}
            disableRipple
            color="default"
            checkedIcon={<StyledCheckedIcon />}
            icon={<StyledIcon />}
            {...props}
        />
    );
}
